import React, { useState, useEffect } from 'react';
import { Oval } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

const EnhanceFETP = ({ isOpen, onClose, userData }) => {
    const [formData, setFormData] = useState({
        // Previous work information
        previousWorkplace: '',
        employmentYear: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        country: '',

        // FETP Frontline
        hasFETPFrontline: 'no',
        frontlineProgram: '',
        frontlineCohort: '',
        frontlineCompletion: '',

        // FETP Intermediate
        hasFETPIntermediate: 'no',
        intermediateProgram: '',
        intermediateCohort: '',
        intermediateCompletion: '',

        // FELTP Advanced
        hasFELTPAdvanced: 'no',
        advancedProgram: '',
        advancedCohort: '',
        advancedCompletion: '',

        // Highest level (auto-populated)
        highestLevel: '',
        highestProgram: '',
        highestCohort: '',
        highestCompletion: ''
    });

    

    // Effect to merge user data into form when component mounts or userData changes
    useEffect(() => {
        if (userData && userData.fetp_courses && userData.fetp_courses.length > 0) {
            const updatedFormData = { ...formData };

            userData.fetp_courses.forEach(course => {
                switch (course.level) {
                    case 'Frontline':
                        updatedFormData.hasFETPFrontline = 'yes';
                        updatedFormData.frontlineProgram = course.name ?? '';
                        updatedFormData.frontlineCohort = course.cohort_number?.toString() ?? '';
                        updatedFormData.frontlineCompletion = course.year_completed ?? '';
                        break;
                    case 'Intermediate':
                        updatedFormData.hasFETPIntermediate = 'yes';
                        updatedFormData.intermediateProgram = course.name ?? '';
                        updatedFormData.intermediateCohort = course.cohort_number?.toString() ?? '';
                        updatedFormData.intermediateCompletion = course.year_completed ?? '';
                        break;
                    case 'Advanced':
                        updatedFormData.hasFELTPAdvanced = 'yes';
                        updatedFormData.advancedProgram = course.name ?? '';
                        updatedFormData.advancedCohort = course.cohort_number?.toString() ?? '';
                        updatedFormData.advancedCompletion = course.year_completed ?? '';
                        break;
                }
            });

            // Sort courses to determine the highest level
            const sortedCourses = [...userData.fetp_courses].sort((a, b) => {
                const levels = ['Frontline', 'Intermediate', 'Advanced'];
                return levels.indexOf(b.level) - levels.indexOf(a.level);
            });

            const highestCourse = sortedCourses[0];
            updatedFormData.highestLevel = highestCourse?.level ?? '';
            updatedFormData.highestProgram = highestCourse?.name ?? '';
            updatedFormData.highestCohort = highestCourse?.cohort_number?.toString() ?? '';
            updatedFormData.highestCompletion = highestCourse?.year_completed ?? '';

            setFormData(updatedFormData);
        }
    }, [userData]);

    
    

    

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity duration-150">
            <div className="relative bg-white rounded-lg w-full max-w-3xl mx-4 max-h-[90vh] overflow-auto ">
                <div className="">
                    <div className="flex flex-col gap-4 m-3">
                        <div>
                            <p className="text-2xl">FETP Information</p>
                        </div>

                        <form className="grid md:grid-cols-3 gap-4">

                            {/* FETP Frontline */}
                            <div className="bg-gray-50 p-2 rounded-lg border border-gray-200 h-fit shadow-lg">
                                <div className="mb-4">
                                    <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                        Have you completed FETP frontline? *
                                    </label>
                                    <select
                                        name="hasFETPFrontline"
                                        value={formData.hasFETPFrontline}
                                       
                                        className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                       disabled
                                    >
                                        <option value="no">No</option>
                                        <option value="yes">Yes</option>
                                    </select>
                                </div>

                                {formData.hasFETPFrontline === 'yes' && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                                Name of FETP Program *
                                            </label>
                                            <input
                                                type="text"
                                                name="frontlineProgram"
                                                value={formData.frontlineProgram}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                        <div>
                                            <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                                Cohort number *
                                            </label>
                                            <input
                                                type="text"
                                                name="frontlineCohort"
                                                value={formData.frontlineCohort}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                        <div>
                                            <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                                Year of completion *
                                            </label>
                                            <input
                                                type="number"
                                                name="frontlineCompletion"
                                                value={formData.frontlineCompletion}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* FETP Intermediate */}

                            <div className="bg-gray-50 p-2 rounded-lg border border-gray-200 h-fit shadow-lg">
                                <div className="mb-4">
                                    <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                        Have you completed FETP Intermediate? *
                                    </label>
                                    <select
                                        name="hasFETPIntermediate"
                                        value={formData.hasFETPIntermediate}
                                       
                                        className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                       disabled
                                    >
                                        <option value="no">No</option>
                                        <option value="yes">Yes</option>
                                    </select>
                                </div>

                                {formData.hasFETPIntermediate === 'yes' && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                                Name of FETP Program *
                                            </label>
                                            <input
                                                type="text"
                                                name="intermediateProgram"
                                                value={formData.intermediateProgram}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                        <div>
                                            <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                                Cohort number *
                                            </label>
                                            <input
                                                type="text"
                                                name="intermediateCohort"
                                                value={formData.intermediateCohort}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                        <div>
                                            <label className="block mb-2 text-sm font-medium font-lufga text-gray-900">
                                                Year of completion *
                                            </label>
                                            <input
                                                type="number"
                                                name="intermediateCompletion"
                                                value={formData.intermediateCompletion}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* FELTP Advanced */}
                            <div className="bg-gray-50 p-2 rounded-lg border border-gray-200 h-fit shadow-lg">
                                <div className="mb-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-900">
                                        Have you completed FELTP Advanced? *
                                    </label>
                                    <select
                                        name="hasFELTPAdvanced"
                                        value={formData.hasFELTPAdvanced}
                                       
                                        className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                       disabled
                                    >
                                        <option value="no">No</option>
                                        <option value="yes">Yes</option>
                                    </select>
                                </div>
                                {formData.hasFELTPAdvanced === 'yes' && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                Name of FELTP Program *
                                            </label>
                                            <input
                                                type="text"
                                                name="advancedProgram"
                                                value={formData.advancedProgram}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                Cohort number *
                                            </label>
                                            <input
                                                type="text"
                                                name="advancedCohort"
                                                value={formData.advancedCohort}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                Year of completion *
                                            </label>
                                            <input
                                                type="number"
                                                name="advancedCompletion"
                                                value={formData.advancedCompletion}
                                               
                                                className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none block w-full p-2.5"
                                               disabled
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                        </form>
                        <div className='flex justify-end mb-4 gap-2'>
                            <button
                                onClick={onClose}
                                className="font-lufga w-fit text-white bg-gray-500 hover:opacity-90 focus:outline-none rounded-md shadow-md text-sm sm:text-sm px-4 py-2 sm:px-10 sm:py-2 text-center"
                            >
                                Close
                            </button>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnhanceFETP;